export const API = {
  GET_STORE_WISE_META_DATA: 'v1/InterStoreTransfer/GetInterStoreSearchMetaData',
  SEARCH_PRODUCT_INVENTORY: 'v1/productdetails/GetProductByCustomSearch',
  SEARCH_PRODUCT_INTERSTORE: 'v1/InterStoreTransfer/SearchProductInInterStore',
  REQUEST_INTERSTORE_TRANSFER: 'v1/InterStoreTransfer/RequestInterStoreTransfer',
  GET_LADGER_DATA: 'v1/Ledger/GetStoreLedgerByStoreId',
  GET_LEDGER_INVOICE_BY_ID: 'v1/Ledger/GetStoreLedgerReceiptByLedgerId',
  GET_PRODUCT_REQUEST_ITEMS_BY_REQUEST_ID: 'v1/InterStoreTransfer/GetProductRequestItemsByRequestId',
  GET_PRODUCT_REQUEST_RECEVED_LIST: 'v1/InterStoreTransfer/GetProductRequestReceivedList',
  STORE_SHIPMENTS_STATUS: 'v1/InterStoreTransfer/UpdateInterStoreTransferRequestShipmentStatus',
  UPDATE_INTERSTORE_TRANSFER_REQUEST_STATUS: 'v1/InterStoreTransfer/UpdateInterStoreTransferRequestStatus',
  GET_INTERSTORE_INVOICE_BY_REQUEST_ID: 'v1/InterStoreTransfer/GenerateInterStoreTransferDeliveryChallan',
  UPDATE_INTERSTORE_TRANSFER_REQUEST_RECEIVED_STATUS: 'v1/InterStoreTransfer/UpdateInterStoreTransferRequestReceivedStatus',
  UPDATE_INTERSTORE_TRANSFER_REQUEST_PAYMENT_STATUS: 'v1/InterStoreTransfer/UpdateInterStoreTransferRequestPaymentStatus',
  UPLOAD_DOCUMENT: 'v1/InterStoreTransferShipmentProof/SaveShipmentProof',
  GET_DOCUMENT_DETAILS: 'v1/InterStoreTransferShipmentProof/GetProofDetailsByRequestId',

}

